import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView } from '@digital/ui';
import TabelaProjetoOverviewResumo from './tabelaProjetoOverviewResumo';
import TabelaProjetoOverviewDetalhado from './tabelaProjetoOverviewDetalhado';
import { getAllProjetoOverDetalhadoView, getAllProjetoOverView, TabelaProjetoOverViewDetalhadoResult, TabelaProjetoOverViewResult } from '@app/api/tabelaProjetoOverView';
import GraficoProjectsOverview from './graficoProjectsOverview';


const ProjectsOverview = () => {

  const [allProjetoOverDetalhado, setAllProjetoOverDetalhado] = useState<TabelaProjetoOverViewDetalhadoResult[]>();
  const [allTabelaProjetoOverView, setAllTabelaProjetoOverView] = useState<TabelaProjetoOverViewResult[]>();



  const getAllProjetoDetalhado = async () => {

    const result = await getAllProjetoOverDetalhadoView();
    if (result) {
      setAllProjetoOverDetalhado(result);
    }
  }

  const getAllProjetoOver = async () => {

    const result = await getAllProjetoOverView();
    if (result) {
      setAllTabelaProjetoOverView(result);
    }
  }


  useEffect(() => {
    getAllProjetoDetalhado();
    getAllProjetoOver();
  }, [])

  return (
    <SimpleView>
      <GridView noform>
        <TabelaProjetoOverviewResumo dataSourceResult={allTabelaProjetoOverView} />
      </GridView>
    </SimpleView>
  );
};

export default ProjectsOverview;

